import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import Auxiliary from "../../hoc/Auxiliary";
import DateFormated from "../Utils/Date/Date";
import CheckedBox from "../UI/Alerts/CheckedBox";
import StepsBar from "../UI/Alerts/StepsBar";

const getCurrentStep = (followup) => {
    let currentStatus = followup.currentStatusCode;
    for(let i=0; i<followup.statusReferenceList.length; i++) {
        if (followup.statusReferenceList[i].statusReference.code === currentStatus) {
            return (i+1);
        }
    }
    return 1;
}

const OrderStatusPopup = (props) => {
    const {t, i18n} = useTranslation();
    const subaccount = props.subaccount;
    return (
        <Auxiliary>
            <div className="row ">
                <div className="col-6 mb-3">
                    <p>
                        <strong>{subaccount.subAccountCode} - {subaccount.subAccountName}</strong></p>
                    <p>{(subaccount.address.addressLine1) &&
                    <span>{subaccount.address.addressLine1}<br/></span>}
                        {(subaccount.address.addressLine2) &&
                        <span>{subaccount.address.addressLine2}<br/></span>}
                        {(subaccount.address.city) && <span>{subaccount.address.city}</span>}
                        {(subaccount.address.stateOrProvinceCode) &&
                        <span>,&nbsp;{subaccount.address.stateOrProvinceCode}<br/></span>}
                        {subaccount.address.postalCode}
                    </p>
                </div>
                <div className="col-6 mb-3 flex justify-content-end text-right flex-column">
                    <p>   {t('popuporderstatus.accountnumber')}<br/> <strong>{props.header.account}</strong></p>
                    <p>   {t('popuporderstatus.deliverynumber')}<br/> <strong>{props.header.deliveryNumber}</strong></p>
                </div>
            </div>
            {props.followUp.statusReferenceList != null ?
                <React.Fragment>
                    <div className="row">
                        <div className="col-12 mb-3 mt-2">
                            <StepsBar currentstep={getCurrentStep(props.followUp)} steps={props.followUp.statusReferenceList.length}/>
                        </div>
                        <div className="col-6 mb-3">
                            <strong className="strong--fs-18">{t('popuporderstatus.orderbegin')}<br/>
                                <DateFormated date={props.lines.orderDate} withTime={false}/> </strong>
                        </div>
                        {
                            props.followUp.currentStatusCode === 'L' ? '' : <div className="col-6 mb-3 flex justify-content-end text-right">
                                <strong className="strong--fs-18">{(i18n.language === 'fr')?props.lines.deliveryDateLabel.descriptionFr:props.lines.deliveryDateLabel.descriptionEn}<br/>
                                    <span className="span--c-red">
                                <DateFormated date={props.lines.deliveryDate} withTime={false}/>
                            </span></strong>
                            </div>
                        }
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <ul className="checkedboxlist">
                                {props.followUp.statusReferenceList.length > 0 && props.followUp.statusReferenceList.reverse().map((item, index) =>
                                    <CheckedBox key={index} index={index} content={item} lang={i18n.language}
                                                currentStatus={props.followUp.currentStatusCode}/>)}
                            </ul>
                        </div>
                    </div>
                </React.Fragment> : <div>{t('popuporderstatus.nofollowupdata')}</div>
            }
        </Auxiliary>
    );
}

export default OrderStatusPopup;
